import { render, staticRenderFns } from "./EmployeeAdd.vue?vue&type=template&id=72e9212c&"
import script from "./EmployeeAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeAdd.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports